"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuthFlow } from "../auth-flow-context";
import { AuthCredentialKind, AuthMethodId } from "../types";
import GoogleIcon from "@/app/(auth)/google-icon";
import { Button } from "@/components/ui";
import { authService } from "@/services/auth-service";
export function GoogleMethod() {
  const $ = _c(13);
  const {
    state,
    actions,
    meta
  } = useAuthFlow();
  if (state.isInSubFlow) {
    return null;
  }
  if (state.activeMethod === AuthMethodId.EMAIL_LINK) {
    return null;
  }
  const isPending = state.runningMethod === AuthMethodId.GOOGLE;
  const otherIsPending = state.runningMethod !== null && state.runningMethod !== AuthMethodId.GOOGLE;
  const errorMessage = state.errors[AuthMethodId.GOOGLE];
  let t0;
  if ($[0] !== actions || $[1] !== meta) {
    t0 = async () => {
      const attempt = actions.startAttempt(AuthMethodId.GOOGLE, "credential");
      await actions.runAuth(AuthMethodId.GOOGLE, async () => {
        const result = await authService.signInWithGooglePopup();
        if (typeof result === "string") {
          attempt?.fail(new Error(result));
          actions.setError(AuthMethodId.GOOGLE, result);
          return null;
        }
        await meta.onSuccess({
          kind: AuthCredentialKind.GOOGLE,
          user: result.user,
          googleCredential: result.credential
        }, attempt);
        return result.user;
      }, attempt);
    };
    $[0] = actions;
    $[1] = meta;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onClick = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GoogleIcon className="h-5 w-5" aria-hidden={true} />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isPending || $[5] !== onClick || $[6] !== otherIsPending) {
    t2 = <Button variant="secondary" type="button" className="w-full" onClick={onClick} disabled={otherIsPending} icon={t1} isLoading={isPending} loadingText="Signing in with Google...">Sign in with Google</Button>;
    $[4] = isPending;
    $[5] = onClick;
    $[6] = otherIsPending;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== errorMessage) {
    t3 = errorMessage && <p className="text-center text-body text-status-error-text" role="alert">{errorMessage}</p>;
    $[8] = errorMessage;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="space-y-2">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}